/**
 * LogoMark — the new emblem PNG contains the full brand mark
 * ("Phantasm Limousine Service Inc.") baked into the artwork, so this component
 * simply renders the image. No accompanying CSS text.
 *
 * Sizes:
 *   sm — emblem 40px tall
 *   md — emblem 64px tall
 *   lg — emblem 96px tall
 */
const SIZES = {
  sm: "h-10",
  md: "h-16",
  lg: "h-24",
};

export default function LogoMark({ size = "md", testid = "logo-mark", ...rest }) {
  // textOnly / hideText are accepted but no longer affect output — the image is the entire logo.
  const cls = SIZES[size] || SIZES.md;
  return (
    <div data-testid={testid} className="flex items-center justify-center select-none">
      <img
        src="/assets/brand/phantasm-emblem.png"
        alt="Phantasm Limousine Service Inc."
        className={`${cls} w-auto`}
        draggable={false}
      />
    </div>
  );
}
